import moment from 'moment';

const states = {
  users_details: {
    users: [],
    users_table_columns: [],
    users_table_filters: {
      searchKey: "",
      limit: 10,
      skip: 0,
    },
    users_table_pagination: {
      more_pages: true,
      current: 1,
    },
    user_profile: {
      filters: {
        date_range: [moment(new Date(), "DD-MM-YYYY").subtract(29, "days"), moment(new Date(), "DD-MM-YYYY")],
        date_range_type: "last_30_days",
        platform: "all",
      },
      basic_info: {},
      stats: [],
      event_histogram: [],
      chatlog_list: [],
      chatlog_list_filters: [],
      chatlog_list_selected_filters: {},
      chatlog_list_pagination: {
        load_more: false,
        required: 20,
        total: 0,
      },
      active_chatlog_details: {
        visible: false,
        chatlog_item: null,
        messages: [],
        chat_profile: {}
      }
    },
    loaders: {
      users_and_columns_loading: false,
      users_and_columns_loaded: false,
      users_loading: false,
      users_load_error: false,
      user_info_loading: false,
      user_info_loaded: false,
      stats_loading: false,
      event_histogram_loading: false,
      event_histogram_load_error: false,
      chatlog_list_loading: false,
      active_chatlog_details_loading: false,
      active_chatlog_details_load_error: false,
    }
  }
};

export default states;


// WEBPACK FOOTER //
// ./src/data/redux/users_details/states.js